import { iaRa } from 'lib/helpers/utility';

export const selectSupervisingProvider = (setClaim, event, supervisingProviders) => {
  const supervisingProvider = iaRa(supervisingProviders)?.find(
    (provider) => provider?.id === event?.value
  );

  setClaim((prevClaim) => ({
    ...prevClaim,
    supv_prov_name_l: supervisingProvider?.l_name || '',
    supv_prov_name_f: supervisingProvider?.f_name || '',
    supv_prov_name_m: supervisingProvider?.m_name || '',
    supv_prov_id: supervisingProvider?.prov_id || '',
    supv_prov_npi: supervisingProvider?.npi || ''
  }));
};
